import PortalIdParser from 'PortalIdParser';
import { setSetting, getSetting } from 'calling-internal-common/utils/localSettings';
export class _CrossTabManager {
  // Default value for usesCallingWindow = false

  constructor() {
    this.INITIAL_TAB_LAST_UPDATED_DATA = {
      lastUpdatedTabId: '',
      lastUpdated: 0
    };
    this.INITIAL_TAB_LIST_DATA = {};
    this.connectionId = '';
    this.storageTabListKey = 'Tab_List-{portalId}';
    this.storageTabLastUpdatedKey = `Tab_Master-{portalId}`;
    this.storageTabListKey = `Tab_List-${PortalIdParser.get()}`;
  }
  getConnectionId() {
    return this.connectionId;
  }
  getNextConnectionId() {
    const data = this.getTabListData();
    const nextTab = Object.keys(data).find(tabId => tabId !== this.connectionId && data[tabId]);
    return nextTab;
  }
  getLastUpdatedTab() {
    const value = getSetting(this.storageTabLastUpdatedKey);
    const data = value || this.INITIAL_TAB_LAST_UPDATED_DATA;
    return data.lastUpdatedTabId;
  }
  getLastUpdated() {
    const value = getSetting(this.storageTabLastUpdatedKey);
    const data = value || this.INITIAL_TAB_LAST_UPDATED_DATA;
    return data.lastUpdated;
  }
  setLastUpdatedTab(tabId) {
    const value = {
      lastUpdatedTabId: tabId || this.connectionId,
      lastUpdated: Date.now()
    };
    setSetting(this.storageTabLastUpdatedKey, value);
  }
  matchesLastUpdatedTab() {
    const lastUpdatedTab = this.getLastUpdatedTab();
    const data = this.getTabListData();
    if (data && data[lastUpdatedTab]) {
      return lastUpdatedTab === this.connectionId;
    }

    // Elect new master tab if the current master tab is disconnected
    const nextTab = this.getNextConnectionId();
    if (nextTab) {
      this.setLastUpdatedTab(nextTab);
    }
    return false;
  }
  getTabListData() {
    const value = getSetting(this.storageTabListKey);
    return value || this.INITIAL_TAB_LIST_DATA;
  }
  setTabListData(updatedData) {
    if (!this.connectionId) return;
    if (updatedData) {
      setSetting(this.storageTabListKey, updatedData);
      return;
    }
    const data = this.getTabListData();
    setSetting(this.storageTabListKey, Object.assign({}, data, {
      [this.connectionId]: Date.now()
    }));
  }
  resetCrossTabData() {
    setSetting(this.storageTabLastUpdatedKey, this.INITIAL_TAB_LAST_UPDATED_DATA);
    setSetting(this.storageTabListKey, this.INITIAL_TAB_LIST_DATA);
  }
}
export const crossTabManager = new _CrossTabManager();